import { DataTable, DataTableColumn } from "@admin/components/molecules/Table";
import {
  FoodControlPointInstanceDto,
  isDisplayNameTypes,
  useControlPointTypeTranslations,
} from "@enos-monorepo/lib";
import { useTranslation } from "react-i18next";

interface OverDueControlsTableProps {
  expiredControls: FoodControlPointInstanceDto[];
  onRowSelection: (selected: FoodControlPointInstanceDto[]) => void;
}

export function OverDueControlsTable({
  expiredControls,
  onRowSelection,
}: OverDueControlsTableProps) {
  const { t, i18n } = useTranslation();
  const controlPointTypeTranslations = useControlPointTypeTranslations();

  const columns: DataTableColumn<FoodControlPointInstanceDto>[] = [
    {
      header: t("food.Overdue Controls"),
      accessorKey: "controlPoint",
      cell: ({ row }) => (
        <div>
          {row.original.controlPoint?.type &&
            (!isDisplayNameTypes(row.original.controlPoint?.type)
              ? controlPointTypeTranslations[row.original.controlPoint?.type]
              : row.original.controlPoint?.name)}
        </div>
      ),
    },
    {
      header: t("food.Due Date"),
      accessorKey: "endDate",
      cell: ({ row }) => (
        <div>
          {Intl.DateTimeFormat(i18n.language, {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }).format(new Date(row.original.endDate))}
        </div>
      ),
    },
  ];
  const handleRowSelectChange = (
    selectedRows: FoodControlPointInstanceDto[],
  ) => {
    onRowSelection(selectedRows);
  };

  return (
    <DataTable
      data={expiredControls}
      columns={columns}
      title={t("food.Overdue Controls")}
      rowSelect
      onRowsSelectChange={handleRowSelectChange}
    />
  );
}
